import React, {useState} from 'react';
import {Box} from "@mui/material";
import {IAppDoctorTimesResult} from "../../store/rtk-api/appointment_times/types";
import {convertDate} from "../common/helper";

type Props = {
    doctor: IAppDoctorTimesResult,
    day: Date
}

// @ts-ignore
const CalendarAppointmentsList: React.FC<Props> = ({ doctor, day}) => {
    const [hover, setHover] = useState(false)
    const cancel = new Map()
    let date = ''
    if (day) {
        date = convertDate(day)
    } else {
        date = ''
    }
    let arr = doctor?.appoint_times?.map(time => {
        if (time.date === date) return date
    })
    let successArray = doctor?.appoint_times?.map(time => {
        if (time.date === date) return time.times?.length
    })

    const now = new Date()
    const getTimeFromDate = (time: string) => {
        return +new Date(`${date}T${time}`)
    }



    if (doctor?.appoint_times.map(app_times => {
        if (app_times.times.length > 0 && date === convertDate(now)){
            let maxTime;
            maxTime = Math.max(...app_times.times?.map(time => {
                return getTimeFromDate(time.start_time)
            }))
            let nowTime = getTimeFromDate(`${now.getHours()}:${now.getMinutes()}:00`)
            if (maxTime < nowTime) {
                cancel.set(app_times.date, doctor.id)
            }
        }
    }))

    return (
        <Box sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            // borderRight: "2px solid #c9c7c7",
            height: "100%",
            minWidth: "52px",
        }}>
            {
                <>
                    {doctor?.appoint_times.length === 0 && <Empty hover={hover} setHover={setHover}/>}
                    {doctor?.appoint_times.length !== 0
                        && arr.includes(date)
                        && cancel.get(date)!==doctor.id
                        && successArray.join('')!=='0'
                        && <Success arr={successArray}/>}
                    {doctor?.appoint_times.length !== 0
                        && arr.includes(date)
                        && cancel.get(date)!==doctor.id
                        && successArray.join('')==='0'
                        && <DayOff arr={successArray}/>}
                    {doctor?.appoint_times.length !== 0
                        && arr.includes(date)
                        && cancel.get(date)===doctor.id
                        && <Cancelled arr={successArray}/>}

                    {doctor?.appoint_times.length !== 0 && !arr.includes(date) &&
                        <Empty hover={hover} setHover={setHover}/>}

                </>

            }
        </Box>
    )
};
type Props2 = {
    hover: boolean,
    setHover(flag: boolean): void
}
const Empty: React.FC<Props2> = ({hover, setHover}) => {
    return (
        <Box sx={{
            boxSizing: "border-box",
            minHeight: "60px",
            // minWidth: "52px",
            width: "100%",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#D9D9D9",
            color: "text.secondary",
            borderBottom: "2px solid #c9c7c7",
            borderRight: "2px solid #c9c7c7",
            position: "relative",
            '&::before': !hover ? {
                content: '""',
                display: 'block',
                height: "12px",
                width: "8px",
                borderRadius: "10px",
                position: "absolute",
                border: "2px solid #FFF",
            } : {content: '""'},
            "&:hover": {
                boxSizing: "border-box",
                border: "3px solid #FFE600",
                color: "text.secondary",
                // width:"96%",
                // height:"96%",
                '&::after': {
                    content: '""',
                    display: 'block',
                    height: "40px",
                    width: "40px",
                    borderRadius: "50px",
                    position: "absolute",
                    border: "3px solid #FFE600",
                    color: "text.secondary",
                },
                '&::before': {
                    content: '"+"',
                    fontSize: "30px",
                    fontWeight: 200,
                    position: "absolute",
                    top: "3px",
                    left: "auto",
                    color: "#FFE600",
                },

            },
        }}
             onMouseOver={() => setHover(true)}
             onMouseLeave={() => setHover(false)}
        >

        </Box>
    )
}

type Props3 = {
    arr: any[]
}

const Success: React.FC<Props3> = ({ arr}) => {
    return (
        <Box
            sx={{
                boxSizing: "border-box",
                minHeight: "60px",
                // minWidth: "52px",
                width: "100%",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "secondary.light",
                position: "relative",
                // height: "100%",
                fontWeight:600,
                borderBottom: "1px solid #c9c7c7",
                borderRight: "1px solid #c9c7c7",
                backgroundColor: "#50B987",
                "&:hover": {
                    border: "3px solid #FFE600",
                },
            }}

        >
            {arr?.join('')}
        </Box>
    )
}

const Cancelled: React.FC<Props3> = ({ arr}) => {
    return (
        <Box
            sx={{
                boxSizing: "border-box",
                minHeight: "60px",
                // minWidth: "52px",
                width: "100%",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "secondary.light",
                position: "relative",
                // height: "100%",
                fontWeight:600,
                borderBottom: "1px solid #c9c7c7",
                borderRight: "1px solid #c9c7c7",
                backgroundColor: "#CA4743",
                "&:hover": {
                    border: "3px solid #FFE600",
                },
            }}

        >
            {arr?.join('')}
        </Box>
    )
}

const DayOff: React.FC<Props3> = ({ arr}) => {
    return (
        <Box
            sx={{
                boxSizing: "border-box",
                minHeight: "60px",
                // minWidth: "52px",
                width: "100%",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "secondary.light",
                position: "relative",
                // height: "100%",
                fontWeight:600,
                borderBottom: "1px solid #c9c7c7",
                borderRight: "1px solid #c9c7c7",
                backgroundColor: "#E4860D",
                "&:hover": {
                    border: "3px solid #FFE600",
                },
            }}

        >
            {arr?.join('')}
        </Box>
    )
}

export default React.memo(CalendarAppointmentsList);